module.exports = __webpack_public_path__ + "static/media/search-sample-1.8909b46e.png";